import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { guardString } from "@msuite/utils/strings";
import type { Enums } from "@msuite/utils/types";
import { client } from "@/hono";
import { OrganizationSettingsWorksitesAcknowledgementDefinitionsMenu } from "./organization-settings-worksites-acknowledgement-definitions-menu";
import { createColumns } from "./table-config";

/** Props Interface */
interface OrganizationSettingsWorksitesAcknowledgementDefinitionsProps {
	worksite: Enums<"attendanceWorksiteType">;
	projectId?: string;
}

export function OrganizationSettingsWorksitesAcknowledgementDefinitions({
	worksite,
	projectId,
}: OrganizationSettingsWorksitesAcknowledgementDefinitionsProps) {
	/** Query */
	const {
		data: acknowledgementDefinitions,
		refetch,
		isLoading,
		queryKey,
	} = useQuery({
		queryKey: ["organization", "acknowledgement-definitions", worksite, guardString(projectId)],
		queryFn: async () => {
			const response = await client.organizations["acknowledgement-definitions"].$get({
				query: { worksite, projectId },
			});
			const data = await responseHandler(response);
			return data.acknowledgementDefinitions;
		},
	});

	/** Render */
	return (
		<DataTable
			data={guardArray(acknowledgementDefinitions)}
			columns={createColumns(!!projectId) as any}
			persistenceKey="worksites-acknowledgement-definitions-table"
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={
				<OrganizationSettingsWorksitesAcknowledgementDefinitionsMenu
					worksite={worksite}
					projectId={projectId}
				/>
			}
		/>
	);
}
